// ============================================
// FILE: components/quiz/QuestionsGrid.tsx
// ============================================
import React from 'react';

interface QuestionsGridProps {
  questions: any[];
  onSelectQuestion: (num: 1 | 2) => void;
  goToQuiz: () => void;
}

export const QuestionsGrid: React.FC<QuestionsGridProps> = ({ 
  questions, 
  onSelectQuestion, 
  goToQuiz 
}) => {
  if (!questions || questions.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-2xl max-w-md mx-auto p-6 text-center">
        <h2 className="text-2xl font-bold mb-4">No Questions Available</h2>
        <p className="text-gray-600 mb-4">No questions were selected. Please go back and start the quiz again.</p>
        <button
          onClick={goToQuiz}
          className="bg-gradient-to-r from-purple-500 to-purple-700 text-white px-6 py-2 rounded-lg hover:scale-105 transition-transform"
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-2xl max-w-full mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">📝 Your Questions</h2>
        <button
          onClick={goToQuiz}
          className="text-purple-600 hover:text-purple-800"
        >
          ← Back to Setup
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {questions.map((question, index) => (
          <div
            key={index}
            className="border-2 border-purple-200 rounded-lg p-4 hover:border-purple-600 cursor-pointer transition-all hover:shadow-lg"
            onClick={() => onSelectQuestion((index + 1) as 1 | 2)}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="bg-purple-100 text-purple-800 text-sm font-bold px-3 py-1 rounded-full">
                Question {index + 1}
              </span>
              <span className="text-gray-500 text-sm">
                Surah {question.sura_number}
              </span>
            </div>
            <p className="text-gray-700 line-clamp-2 ayah text-right">
              {question.first_verse || question.verse_text?.substring(0, 100) + '...'}
            </p>
            <div className="mt-2 text-xs text-gray-400">
              Verse {question.aya_number} • Page {question.page}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 text-center text-sm text-gray-500">
        Click on a question to view and answer it
      </div>
    </div>
  );
};